import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Progressive enhancement: turns a plain <select multiple> into a searchable,
// chip-based picker. Works on any select that carries data-controller="tom-select".
export default class extends Controller {
  static values = {
    placeholder: { type: String, default: "Zoek en kies…" }
  }

  connect() {
    this.select = new TomSelect(this.element, {
      plugins: ["remove_button"],
      placeholder: this.placeholderValue,
      maxOptions: null,
      hideSelected: true,
      closeAfterSelect: false,
      // Search both the visible label and the optgroup (tag category) name.
      searchField: ["text", "optgroup"]
    })
  }

  disconnect() {
    this.select?.destroy()
  }
}
